import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "tracksheet-run-passages q-mt-md",
  "data-testid": "tracksheet-run-passages"
}
const _hoisted_2 = { class: "row items-center q-gutter-sm q-pb-sm" }
const _hoisted_3 = {
  key: 0,
  class: "q-pb-sm"
}
const _hoisted_4 = {
  class: "row items-start q-gutter-sm q-pb-sm",
  "data-testid": "tracksheet-run-passages-filter"
}
const _hoisted_5 = { class: "row no-wrap" }
const _hoisted_6 = { class: "row no-wrap" }
const _hoisted_7 = {
  key: 1,
  class: "q-pb-sm text-negative text-caption",
  "data-testid": "tracksheet-run-passages-filter-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_PassagesTable = _resolveComponent("PassagesTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-subtitle1 text-weight-medium" }, "Passages on this run", -1)),
      _createVNode(_component_q_badge, {
        color: "blue-brand",
        "text-color": "white",
        "data-testid": "tracksheet-run-passages-count"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.displayedPassages.length), 1)
        ]),
        _: 1
      }),
      (_ctx.selectedMarkerId != null)
        ? (_openBlock(), _createBlock(_component_q_chip, {
            key: 0,
            removable: "",
            dense: "",
            color: "blue-brand",
            "text-color": "white",
            icon: "place",
            class: "tracksheet-run-passages__marker-chip",
            "data-testid": "tracksheet-run-passages-marker-chip",
            onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear-marker')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.markerChipLabel), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      _createVNode(_component_q_btn, {
        flat: "",
        round: "",
        dense: "",
        icon: "refresh",
        color: "blue-brand",
        loading: _ctx.loading,
        "data-testid": "tracksheet-run-passages-refresh",
        onClick: _ctx.fetchPassages
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("Refresh passages", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_badge, { color: "red" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.errorMsg), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_q_input, {
        modelValue: _ctx.filterFrom,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterFrom) = $event)),
        dense: "",
        filled: "",
        mask: "####-##-## ##:##",
        label: "From (UTC)",
        hint: "YYYY-MM-DD HH:mm",
        style: {"width":"190px"},
        "data-testid": "tracksheet-run-passages-from"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "event",
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_popup_proxy, {
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.filterFrom,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterFrom) = $event)),
                      mask: "YYYY-MM-DD HH:mm"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_q_time, {
                      modelValue: _ctx.filterFrom,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterFrom) = $event)),
                      mask: "YYYY-MM-DD HH:mm",
                      format24h: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_input, {
        modelValue: _ctx.filterTo,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterTo) = $event)),
        dense: "",
        filled: "",
        mask: "####-##-## ##:##",
        label: "To (UTC)",
        hint: "YYYY-MM-DD HH:mm",
        style: {"width":"190px"},
        "data-testid": "tracksheet-run-passages-to"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "event",
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_popup_proxy, {
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.filterTo,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterTo) = $event)),
                      mask: "YYYY-MM-DD HH:mm"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_q_time, {
                      modelValue: _ctx.filterTo,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterTo) = $event)),
                      mask: "YYYY-MM-DD HH:mm",
                      format24h: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_toggle, {
        modelValue: _ctx.filterGreenMl,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterGreenMl) = $event)),
        dense: "",
        label: "Green ML only",
        color: "green",
        class: "q-mt-sm",
        "data-testid": "tracksheet-run-passages-green-ml"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        "no-caps": "",
        label: "Clear",
        color: "blue-brand",
        class: "q-mt-xs",
        disable: !_ctx.filterFrom && !_ctx.filterTo && !_ctx.filterGreenMl,
        "data-testid": "tracksheet-run-passages-clear",
        onClick: _ctx.clearFilters
      }, null, 8, ["disable", "onClick"])
    ]),
    (_ctx.timeFilterRange.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.timeFilterRange.error), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_PassagesTable, {
      ref: "passagesTable",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pagination) = $event)),
      rows: _ctx.displayedPassages,
      columns: _ctx.columns,
      "row-key": _ctx.rowKey,
      "sort-method": _ctx.keepOrder,
      loading: _ctx.loading,
      "no-data-label": _ctx.noDataLabel,
      "dialog-source": _ctx.dialogSource,
      "pig-run-id": _ctx.pigRunId,
      active: _ctx.chartStepsHere,
      "row-opens-chart": _ctx.isNarrow,
      "data-testid": "tracksheet-run-passages-table"
    }, null, 8, ["pagination", "rows", "columns", "row-key", "sort-method", "loading", "no-data-label", "dialog-source", "pig-run-id", "active", "row-opens-chart"])
  ]))
}